<template>
  <div class="trackPlayback">
    <div class="trackPlayback-header">
      <div class="goBack" @click="$router.go(-1)"></div>
      <div class="plateNumber">轨迹回放-{{realtimeData.plateNumber}}</div>
    </div>
    <div class="mapType">
      <div @click="changeMapType(0)" :class="{'active':defaultType==0}">标准</div>
      <div @click="changeMapType(1)" :class="{'active':defaultType==1}">卫星</div>
    </div>
    <div class="keyPoints">
      <div @click="showTrackPoint('alarm')"><img :src="alarmImg()" alt=""></div>
      <div @click="showTrackPoint('leak')"><img :src="leakOilImg()" alt=""></div>
      <div @click="showTrackPoint('fuel')"><img :src="addOilImg()" alt=""></div>
      <div @click="showTrackPoint('park')"><img :src="parkImg()" alt=""></div>
    </div>
    <div class="trackPlayback-map" id="track-map"></div>
    <transition name="realtimeData">
      <div class="realtimeData" v-show="realtimeDataFlag==2">
        <div class="carDes">
          <div class="carImg"><img :src="carTypeImg(realtimeData.carType)" alt /></div>
          <div class="platenumber_alarm">
            <div class="platenumber">{{realtimeData.plateNumber}}</div>
            <div class="alarm">{{replayLineArr[playIndex].alarmtype | alarmStatusFil }}</div>
          </div>
          <div class="closeIcon" @click="realtimeDataFlag=0">×</div>
        </div>
        <div class="realtime">
          <span class="circle"></span>
          <span class="time">{{replayLineArr[playIndex].updatetime}}</span>
        </div>
        <div class="carCurrentMsg">
          <div class="item">
            <div class="value">{{ replayLineArr[playIndex].speed }}<span class="count">km/h</span></div>
            <div class="label">速度</div>
          </div>
          <div class="item">
            <div class="value">{{ replayLineArr[playIndex].mileage }}<span class="count">km</span></div>
            <div class="label">今日里程</div>
          </div>
          <div class="item">
            <div class="value">{{ replayLineArr[playIndex].load || '--' }}<span class="count" v-show="realtimeData.load">km</span></div>
            <div class="label">载重</div>
          </div>
          <div class="item">
            <div class="value" style="font-size:16px;font-weight:700">{{ replayLineArr[playIndex].acc == 0? '熄火' : '点火'}}</div>
            <div class="label">ACC状态</div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="tripMsg"> 
      <div class="tripMsg" v-show="realtimeDataFlag==1">
        <div class="carDes">
            <div class="tripDate">
                <img src="../../assets/image/carLogo.png" alt="">
                {{ realtimeData.statisticsDate }}  {{ realtimeData.startTime | substrTime }}  -  {{ realtimeData.endTime | substrTime }}
            </div>
            <div class="tripAddress">
                <div class="marks">
                    <div class="circleGreen"></div>
                    <div class="line"></div>
                    <div class="circlePink"></div>
                </div>
                <div class="value">
                    <p style="margin-bottom:5px">{{ realtimeData.startAddress }}</p>
                    <p>{{ realtimeData.endAddress }}</p>
                </div>
            </div>
        </div>
        <div class="carMsg">
            <div class="carMsg-item">
                <div class="value">{{ parseInt(realtimeData.avgSpeed) }}<span>km/h</span></div>
                <div class="label">平均速度</div>
            </div>
            <div class="carMsg-item">
                <div class="value">{{ parseInt(realtimeData.maxSpeed) }}<span>km/h</span></div>
                <div class="label">最高速度</div>
            </div>
            <div class="carMsg-item">
                <div class="value">{{ realtimeData.mileage }}<span>km</span></div>
                <div class="label">行驶里程</div>
            </div>
            <div class="carMsg-item">
                <div class="value">{{parseInt(realtimeData.driveTime/60/60)}}<span>h</span>{{parseInt(realtimeData.driveTime/60%60)}}<span>m</span></div>
                <div class="label">行驶时长</div>
            </div>
        </div>
    </div>
    </transition>
    <div class="realtimeDataMini" v-show="realtimeDataFlag==0" @click="realtimeDataFlag=2">
      <img :src="carTypeImg(realtimeData.carType)" alt />
      <span class="line"></span>
      <div class="speed">{{ replayLineArr[playIndex].speed }}<span class="count">km/h</span></div>
    </div>
    <div class="trackPlayback-process">
      <van-slider v-model="playProcess" ref="playProcess" bar-height="3px" active-color="rgba(44,172,133,.5)" inactive-color="rgba(228,231,237,.5)" @input="playProcessChange">
        <template #button>
          <div class="custom-button"></div>
        </template>
      </van-slider>
    </div>
    <div class="playKey"><div><img :src="getPlayStatus()" alt="" @click="trackPlayClick"></div></div>
    <div v-show="false">
      <!-- <div class="transback-infobox" ref="infoboxCon"> 
        <van-icon name="cross" class="close-icon" @click.stop="closeOverLay" />
        <div class="transback-item">设备编号：{{ infoContent.imei }}</div>
        <div class="transback-item">
          设备型号：<span>{{
            infoContent.hardwareProtocol | deviceProtoFil
          }}</span>
        </div>
        <div class="transback-item">
          设备类型：<span>{{ infoContent.type | deviceTypeFil }}</span>
        </div>
      </div> -->
      <div class="transback-pointInfo" ref="parkInfoBox">
        <van-icon name="cross" class="close-icon" @click.stop="parkBox.close()" />
        <div class="transback-item">
          停车时长：<span>{{ parkPointInfo.travelTime }}</span>
        </div>
        <div class="transback-item">
          开始时间：<span>{{ parkPointInfo.startTime }}</span>
        </div>
        <div class="transback-item">
          结束时间：<span>{{ parkPointInfo.endTime }}</span>
        </div>
        <div class="transback-item">
          停车位置：<span>{{ parkPointInfo.startAddress }}</span>
        </div>
      </div>
      <div class="transback-pointInfo" ref="addOilInfoBox">
        <van-icon name="cross" class="close-icon" @click.stop="addOilBox.close()" />
        <div class="transback-item">
          加油升数：<span>{{ addoilPointInfo.addOil }}L</span>
        </div>
        <div class="transback-item">
          加油时间：<span>{{ addoilPointInfo.startTime }}</span>
        </div>
        <div class="transback-item">
          加油位置：<span>{{ addoilPointInfo.address }}</span>
        </div>
      </div>
      <div class="transback-pointInfo" ref="leakOilInfoBox">
        <van-icon name="cross" class="close-icon" @click.stop="oilLeakageBox.close()" />
        <div class="transback-item">
          漏油升数：<span>{{ leakOilPointInfo.oilLeakage }}L</span>
        </div>
        <div class="transback-item">
          漏油时间：<span>{{ leakOilPointInfo.startTime }}</span>
        </div>
        <div class="transback-item">
          漏油位置：<span>{{ leakOilPointInfo.address }}</span>
        </div>
      </div>
      <div class="transback-pointInfo" ref="alarmInfoBox">
        <van-icon name="cross" class="close-icon" @click.stop="alarmBox.close()" />
        <div class="transback-item">
          报警类型：<span style="color:#E02020">{{
            alarmPointInfo.alarmType | alarmStatusFil
          }}</span>
        </div>
        <div class="transback-item">
          报警时间：<span>{{
            alarmPointInfo.alarmStartTime | dateFormateFil
          }}</span>
        </div>
        <div class="transback-item">
          报警位置：<span>{{ alarmPointInfo.alarmAddress }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    const imageArr = ["", "green_car_", "red_car_", "yellow_car_", "black_car_", "location_gray_car_", "purple_car_", "blue_car_", "wireless_gray_car_", "car_cyan_"];
    export default {
        data() {
            return {
                searchDate:{},
                key:'',
                defaultType: 0,
                aMap: null,
                aMapInfo: null,
                aMapInfoOpen: null,
                trafficLayer: null,
                layer:null,
                parkVisible: false,
                fuelVisible: false,
                leakVisible: false,
                alarmVisible: false,
                show:true,
                playspeed: 10000,
                realtimeDataFlag:1,
                playProcess:0,
                realtimeData:{},
                mapMarker: null,
                navgMove: false,
                startMove: true,
                replayLineArr: [{}],
                transformLine: [],
                // infoContent: {},
                parkPointInfo: {},
                alarmPointInfo: {},
                addoilPointInfo: {},
                leakOilPointInfo: {},
                playIndex: 0,
                isOnSlider:false,
                // infoBox: null,
                parkBox: null,
                alarmBox: null,
                addOilBox: null,
                oilLeakageBox: null,
                passedPolyline: null,
                mapBounds: null,
                closestIndex: null,
                closestMarker: null,
                strokeWeight: 6,
                parkData: [],
                alarmData: [],
                parkMarks: [],
                alarmMarks: [],
                fuelMarks: [],
                fuelPoints: [],
                leakmarks: [],
                leakPoints: [],
                highSpeed:90,
                lowSpeed:40
            }
        },
        watch: {
          playIndex(val, ol) {
            this.playProcess = val / (this.replayLineArr.length - 1) * 100
            let hidhlightRow = this.replayLineArr[val]
            if (this.navgMove) {
              this.drawMapMarker(val, ol)
            }
          },
          // navgMove(val) {
          //   if (this.replayline.length > 0) {
          //     if (val) {
          //       this.infoBox.close()
          //     } else {
          //       this.infoBox.open(this.aMap, this.mapMarker.getPosition())
          //     }
          //   }
          // },
          parkVisible(val) {
            if (val) {
              this.showParkMarks()
            } else {
              this.aMap.remove(this.parkMarks)
              this.parkMarks = []
            }
          },
          alarmVisible(val) {
            if (val) {
              this.showalarmMarks()
            } else {
              this.aMap.remove(this.alarmMarks)
              this.alarmMarks = []
            }
          },
          fuelVisible(val) {
            if (val) {
              this.showfuelMarks()
            } else {
              this.aMap.remove(this.fuelMarks)
              this.fuelMarks = []
            }
          },
          leakVisible(val) {
            if (val) {
              this.showLeakMarks()
            } else {
              this.aMap.remove(this.leakmarks)
              this.leakmarks = []
            }
          },
        },
        mounted() {
          this.searchDate = this.$route.query
          this.key = this.$route.query.key
          this.getTravelMsg()
          this.aMap = new AMap.Map('track-map', {
            zoom: 11,//级别
            center: [120.19574222222222, 30.346933333333332],//中心点坐标
            mapStyle:'amap://styles/fresh'
          });
          this.layer = new AMap.TileLayer.Satellite();
          this.$refs.playProcess.$el.addEventListener("click", e => {
            if (!this.mapMarker) return false
            this.mapMarker.stopMove()
            this.navgMove = false
            let stopPoint = parseInt(this.playProcess / 100 * this.replayLineArr.length - 1)
            this.movePoint(stopPoint)
          }, false)
          this.$refs.playProcess.$el.addEventListener("touchstart", e => {
            this.isOnSlider = true
          }, false)
          document.addEventListener("touchend", e => {
            this.isOnSlider = false
          }, false)
          // this.infoBox = new AMap.InfoWindow({
          //   isCustom: true,  //使用自定义窗体
          //   offset: new AMap.Pixel(-5, -30)
          // });
          this.parkBox = new AMap.InfoWindow({
            isCustom: true,  //使用自定义窗体
            offset: new AMap.Pixel(40, -40)
          });
          this.alarmBox = new AMap.InfoWindow({
            isCustom: true,  //使用自定义窗体
            offset: new AMap.Pixel(40, -40)
          });
          this.addOilBox = new AMap.InfoWindow({
            isCustom: true,  //使用自定义窗体
            offset: new AMap.Pixel(40, -40)
          });
          this.oilLeakageBox = new AMap.InfoWindow({
            isCustom: true,  //使用自定义窗体
            offset: new AMap.Pixel(40, -40)
          });
          this.aMap.on('moveend', this.setBounds)
          this.aMap.on('complete', this.setBounds)
          this.aMap.on('mousemove', this.mouseoveLine)
          this.getReplayList(this.searchDate)
        },
        filters: {
          deviceTypeFil(val) {
            let typeObj = {
              1: "GPS有线设备",
              2: "GPS无线设备",
              3: "OBD设备"
            }
            return typeObj[val]
          },
          substrTime(time) {
            if(time) {
              let time1 = new Date(time.replace(/-/g, "/"))
              let H = time1.getHours()<10?'0'+time1.getHours():time1.getHours()
              let M = time1.getMinutes()<10?'0'+time1.getMinutes():time1.getMinutes()
              let getTime = H+':'+M
              return getTime
            }
          },
          deviceProtoFil(val) {
            let typeObj = {
              1: "WYMinis",
              3: "WYOBD",
              4: "WYOBD带车况",
              5: "行车记录仪",
              6: "云镜",
              7: "WY05",
              8: "WYP9",
              9: "WYA4C",
              10: "WY200"
            }
            return typeObj[val]
          },
          alarmStatusFil(val) {
            let StatusObj = {
              0: "正常", 1: "断电报警", 2: "超速报警", 3: "低电压报警", 4: "离线超时报警", 5: "出行政区域报警", 6: "出围栏报警", 7: "进区域报警", 8: "出区域报警", 9: "线路偏移报警", 10: "非法拆除报警", 11: "怠速报警", 12: "低速报警", 13: "疲劳驾驶报警", 14: "高温报警", 15: "低温报警", 16: "高湿度报警", 17: "低湿度报警", 18: "胎压过低报警", 19: "胎压过高报警", 20: "胎温过高报警", 21: "胎压传感器异常报警", 22: "胎压不平衡报警", 23: "慢漏气报警", 24: "胎压传感器电量过低报警", 25: "超载报警"
            }
            return StatusObj[val]
          },
          dateFormateFil(val) {
            return val
          }
        },
        methods: {
          async getTravelMsg() {
            const data = await this.$api.getTravelList(this.key,
                {beginTime: this.searchDate.beginTime, endTime: this.searchDate.endTime})
            if(data.success) {
              this.realtimeData = data.datas.content[0] || []
            }
          },
          changeMapType(type) {
            this.defaultType = type
            if(type==0) {
              this.aMap.remove(this.layer)
            }else {
              this.aMap.add(this.layer)
            }
          },
          alarmImg() {
            return require(`@/assets/image/markPoints/${this.alarmVisible?'baojing_checked':'baojing'}.png`)
          },
          leakOilImg() {
            return require(`@/assets/image/markPoints/${this.leakVisible?'louyou_checked':'louyou'}.png`)
          },
          addOilImg() {
            return require(`@/assets/image/markPoints/${this.fuelVisible?'jiayou_checked':'jiayou'}.png`)
          },
          parkImg() {
            return require(`@/assets/image/markPoints/${this.parkVisible?'tingche_checked':'tingche'}.png`)
          },
          carTypeImg(val) {
            if (!val) return;
            return require(`@/assets/image/carType/${val}.png`);
          },
          trackPlayClick() {
            if (!this.mapMarker) return false
            if (this.startMove) {
              this.startMove = false
              this.mapMarker.on('moveend', (e) => {
                if (this.navgMove) {
                  this.drawContinue()
                }
              });
              this.mapMarker.on('moving', e => {
                let passLineArr = this.transformLine.slice(0, this.playIndex)
                this.passedPolyline.setPath(passLineArr);
              })
              this.drawContinue()
              this.navgMove = true
            } else {
              if (this.navgMove) {
                this.mapMarker.stopMove()
              } else {
                this.drawContinue()
              }
              this.navgMove = !this.navgMove
            }
            if(this.playIndex == 1) {
              this.realtimeDataFlag = 2
            }
          },
          drawContinue() {
            let nextIndex = this.playIndex + 1
            if (nextIndex < this.replayLineArr.length) {
              this.playIndex = nextIndex
            }
          },
          movePoint(playIndex) {
            let currentPoint = this.transformLine[playIndex],
              { status, direct } = this.replayLineArr[playIndex]
            this.playIndex = playIndex
            let passLineArr = this.transformLine.slice(0, this.playIndex + 1)
            this.passedPolyline.setPath(passLineArr);
            let imagePath = `${imageArr[status]}${this.getDirectInfo(direct).image}`
            let icons = require(`@/assets/image/monitornew/${imagePath}`)
            this.mapMarker.setIcon(icons)
            this.mapMarker.setAngle(0)
            this.mapMarker.setPosition(currentPoint);
            if (this.isOutOfBounds(currentPoint, this.mapBounds)) {
              this.aMap.setCenter(currentPoint);
            }
          },
          mouseoveLine(e) {
            var lnglat = e.lnglat;
            var cloesest = null, index = null;
            if (this.transformLine.length == 0) {
              return;
            }
            for (var i = 0, len = this.transformLine.length; i < len; i++) {
              var item = this.transformLine[i];
              if (this.isOutOfBounds(item, this.mapBounds)) {
                continue;
              }
              var distance = lnglat.distance(item);
              if (cloesest === null || cloesest > distance) {
                cloesest = distance;
                index = i;
              }
            }
            var nearDistance = this.getNearDistance();
            if (cloesest !== null && cloesest < nearDistance) {
              if (this.closestIndex != index) {
                if (this.closestMarker) {
                  this.aMap.remove(this.closestMarker);
                }
                let icons = require(`@/assets/image/circle.svg`)
                this.closestMarker = new AMap.Marker({
                  map: this.aMap,
                  position: this.transformLine[index],
                  offset: new AMap.Pixel(-10, -10), //相对于基点的位置
                  icon: new AMap.Icon({
                    size: new AMap.Size(20, 20), //图标大小
                    image: icons,
                    imageOffset: new AMap.Pixel(0, 0)
                  }),
                  extData: index,
                  zIndex: 70
                });

                AMap.event.addListener(this.closestMarker, 'click', (ee) => {
                  var markerIndex = ee.target.getExtData();
                  this.mapMarker.stopMove()
                  this.navgMove = false
                  this.movePoint(markerIndex)
                });

                this.closestIndex = index;
              }
            } else if (this.closestMarker) {
              this.aMap.remove(this.closestMarker);
              this.closestMarker = null;
              this.closestIndex = null;
            }
          },
          initPolyline() {
            let colors = this.getParaColor()
            let colorKeys = Object.keys(colors);
            for (var i = 0; i < colorKeys.length; i++) {
              var colorItem = colors[colorKeys[i]];
              for (var j = 0; j < colorItem.segment.length; j++) {
                var lineSegment = new AMap.Polyline({
                  map: this.aMap,
                  path: this.transformLine.slice(colorItem.segment[j].startIndex, colorItem.segment[j].endIndex),
                  strokeColor: colorItem.color, //线颜色
                  strokeOpacity: 0.9, //线透明度
                  strokeWeight: this.strokeWeight, //线宽
                  strokeStyle: "solid", //线样式
                  zIndex: 50,
                  showDir: true
                });
                this.replayline.push(lineSegment);
              }
            }
            this.passedPolyline = new AMap.Polyline({
              map: this.aMap,
              strokeColor: "#000", //线颜色
              strokeOpacity: 0.35,
              strokeWeight: this.strokeWeight //线宽
            });
          },
          getColorType(speed) {
            if (speed === undefined) {
              return '';
            }
            speed = parseInt(speed);
            if (speed >= this.highSpeed) {
              return 'high';
            } else if (speed >= this.lowSpeed && speed < this.highSpeed) {
              return 'normal';
            }
            return 'low';
          },
          getParaColor() {
            var typeDict = {};
            let pathData = this.replayLineArr.concat([{
              x: Math.random()
            }]);
            if (pathData.length > 0) {
              let prevType = this.getColorType(pathData[0].speed);
              let prevIndex = 0;

              for (let i = 0; i < pathData.length; i++) {
                let element = pathData[i];
                //获取当前点的状态
                var currentType = this.getColorType(element.speed);
                //如果当前状态与前一个点的状态不相同
                if (currentType !== prevType) {
                  //获取当前颜色类型的数据
                  var item = typeDict[prevType];
                  //设置当前路线段的起始截止点
                  var segment = {
                    startIndex: prevIndex,
                    endIndex: i,
                  };
                  //如果已存在当前颜色 累加数据 
                  if (item) {
                    item.segment.push(segment);
                  } else {
                    // 不存在则新建一个数据
                    typeDict[prevType] = {
                      type: prevType,
                      segment: [segment],
                    };
                  }
                  prevType = currentType;
                  prevIndex = i - 1;
                }
              }
            }
            if (typeDict.high) {
              // typeDict.high.color = '#E02020';
              typeDict.high.color = '#02C47A';
            }
            if (typeDict.normal) {
              typeDict.normal.color = '#02C47A';
            }
            if (typeDict.low) {
              // typeDict.low.color = '#FA6400 ';
              typeDict.low.color = '#02C47A ';
            }
            return typeDict
          },
          setBounds() {
            var bounds = this.aMap.getBounds();
            var southwest = bounds.getSouthWest();//获取西南角坐标
            var northeast = bounds.getNorthEast();//获取东北角坐标
            var possa = southwest.lat;//纬度（小）
            var possn = southwest.lng;
            var posna = northeast.lat;
            var posnn = northeast.lng;
            this.mapBounds = [
              [possn, possa], //西南角坐标
              [posnn, posna]//东北角坐标
            ];
          },
          isOutOfBounds(lnglat, bounds) {
            if (
              lnglat[0] <= bounds[0][0]
              || lnglat[1] <= bounds[0][1]
              || lnglat[0] >= bounds[1][0]
              || lnglat[1] >= bounds[1][1]
            ) {
              return true;
            }
            return false;
          },
          shouldJump(x1, y1, x2, y2, speed) {
            if (x2 == 0 && y2 == 0 || (x2 == '114.059264' && y2 == '22.612487')) {
              return true;
            }
            var distance = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
            var thresholdValue = 0.00002;
            if (speed === 10000) {
              thresholdValue = 0.00004;
            } else if (speed === 20000) {
              thresholdValue = 0.00008;
            } else if (speed === 40000) {
              thresholdValue = 0.00016;
            } else if (speed === 80000) {
              thresholdValue = 0.00032;
            }else if (speed === 160000) {
              thresholdValue = 0.00064;
            }
            if (distance <= thresholdValue) {
              return true;
            }
            return false;

          },
          getNearDistance() {
            var zoom = this.aMap.getZoom();
            var mouseToLineDistance;
            if (zoom < 5) {
              mouseToLineDistance = (30 - zoom) * 400;
            } else if (zoom < 8) {
              mouseToLineDistance = (30 - zoom) * 300;
            } else if (zoom < 11) {
              mouseToLineDistance = (30 - zoom) * 150;
            } else if (zoom < 14) {
              mouseToLineDistance = (30 - zoom) * 30;
            } else if (zoom < 15) {
              mouseToLineDistance = (30 - zoom) * 20;
            } else if (zoom < 17) {
              mouseToLineDistance = (30 - zoom) * 6;
            } else {
              mouseToLineDistance = (30 - zoom) * 2;
            }
            return mouseToLineDistance * 2;
          },
          resetPlay() {
            this.playIndex = 0
            this.playProcess = 0
            this.startMove = true
            this.navgMove = false
            // this.infoBox.close()
            this.parkVisible = false
            this.alarmVisible = false
            this.fuelVisible = false
            this.leakVisible = false
          },
          getReplayList({beginTime,endTime}) {
            this.aMap.clearMap();
            this.replayline = []
            this.resetPlay()
            this.$api.getTrackList(this.key,{beginTime,endTime}).then(data => {//获取轨迹回放数据
              if (data.success) {
                // this.replayLineArr = _.flattenDeep(data.datas.content.map(item => {
                //   let info = pako.ungzip(item, { to: 'string' });
                //   return JSON.parse(info)
                // }))
                this.replayLineArr = data.datas.content
                if (this.replayLineArr.length > 0) {
                  //创建车辆标记
                  let startPoint = this.replayLineArr[0]
                  let imagePath = `${imageArr[startPoint.status]}${this.getDirectInfo(startPoint.direct).image}`
                  let icons = require(`@/assets/image/monitornew/${imagePath}`)
                  this.transformLine = this.replayLineArr.map(item => [item.lng, item.lat])
                  var distance = Math.round(AMap.GeometryUtil.distanceOfLine(this.transformLine));
                  this.initPolyline()

                  this.mapMarker = new AMap.Marker({
                    map: this.aMap,
                    position: this.transformLine[0],
                    icon: new AMap.Icon({
                      size: new AMap.Size(35, 35),
                      image: icons,
                      imageSize: new AMap.Size(35, 35),
                    }),
                    zIndex: 200,
                    autoRotation: true,
                    offset: new AMap.Pixel(-17, -17),
                  });
                  let startMark = new AMap.Marker({
                    map: this.aMap,
                    position: this.transformLine[0],
                    icon: new AMap.Icon({
                      size: new AMap.Size(30, 35),
                      image: require(`@/assets/image/mapMark/startPoint.png`),
                      imageSize: new AMap.Size(30, 35),
                    }),
                    zIndex: 80,
                    offset: new AMap.Pixel(-12, -12),
                  });
                  let endMark = new AMap.Marker({
                    map: this.aMap,
                    position: this.transformLine[this.transformLine.length - 1],
                    icon: new AMap.Icon({
                      size: new AMap.Size(30, 35),
                      image: require(`@/assets/image/mapMark/endPoint.png`),
                      imageSize: new AMap.Size(30, 35),
                    }),
                    zIndex: 80,
                    offset: new AMap.Pixel(-12, -12),
                  });
                  this.aMap.setFitView();
                  this.aMap.setCenter(startMark.getPosition());
                }
              }
            })
            this.getReplayPark(this.searchDate)
            this.getReplayAlarm(this.searchDate)
            this.getFuelPoint(this.searchDate)
            this.getLeakPoint(this.searchDate)
            // this.getInfobox()
          },
          // getInfobox() {//获取车辆infobox信息
          //   this.infoContent = {
          //     hardwareProtocol:1,
          //     type:1,
          //     imei:'1358250111'
          //   }
          //   let infoboxHTML = this.$refs.infoboxCon
          //   this.infoBox.setContent(infoboxHTML)
          // },
          getReplayPark({ beginTime,endTime }) {//获取停车点数据
            this.$api.getParkPoints(this.key,{beginTime,endTime}).then(data => {
              if (data.success) {
                this.parkData = data.datas.content
              }
            })
          },
          getReplayAlarm({ beginTime,endTime }) {//获取报警点数据
            this.$api.getAlarmPoints(this.key,{beginTime,endTime}).then(data => {
              if (data.success) {
                this.alarmData = data.datas.content
              }
            })
          },
          getFuelPoint({ beginTime,endTime }) {//获取加油点数据
            this.$api.getAddoilPoints(this.key,{beginTime,endTime}).then(res => {
              this.fuelPoints = res.datas.content
            })
          },
          getLeakPoint({ beginTime,endTime }) {//获取漏油点数据
            this.$api.getLeakPoints(this.key,{beginTime,endTime}).then(res => {
              this.leakPoints = res.datas.content
            })
          },
          showParkMarks() {
            // let parkPoints = _.filter(this.parkData, item => item.travelTimeNum > this.parkTime)
            let parkPoints = this.parkData
            parkPoints.forEach(item => {
              let icons = require(`@/assets/image/mapMark/parkPoint.png`)
              let markIcon = new AMap.Icon({
                size: new AMap.Size(80, 35),
                image: icons,
                imageSize: new AMap.Size(80, 35),
              });
              let marker = new AMap.Marker({
                position: [item.startLng, item.startLat],
                icon: markIcon,
                map: this.aMap,
                cursor: 'pointer',
                zIndex: 140,
              });
              AMap.event.addListener(marker, 'click', (e) => {
                this.parkPointInfo = item
                let infoboxHTML = this.$refs.parkInfoBox
                this.parkBox.setContent(infoboxHTML)
                this.parkBox.open(this.aMap, marker.getPosition());
              });
              this.parkMarks.push(marker)
            })
          },
          showfuelMarks() {
            this.fuelPoints.forEach(item => {
              let icons = require(`@/assets/image/mapMark/fuelPoint.png`)
              let markIcon = new AMap.Icon({
                size: new AMap.Size(80, 35),
                image: icons,
                imageSize: new AMap.Size(80, 35),
              });
              let marker = new AMap.Marker({
                position: [item.lng, item.lat],
                icon: markIcon,
                map: this.aMap,
                zIndex: 150,
              });
              AMap.event.addListener(marker, 'click', (e) => {
                this.addoilPointInfo = item
                let infoboxHTML = this.$refs.addOilInfoBox
                this.addOilBox.setContent(infoboxHTML)
                this.addOilBox.open(this.aMap, marker.getPosition());
              });
              this.fuelMarks.push(marker)
            })
          },
          showLeakMarks() {
            this.leakPoints.forEach(item => {
              let icons = require(`@/assets/image/mapMark/leakPoint.png`)
              let markIcon = new AMap.Icon({
                size: new AMap.Size(80, 35),
                image: icons,
                imageSize: new AMap.Size(80, 35),
              });
              let marker = new AMap.Marker({
                position: [item.lng, item.lat],
                icon: markIcon,
                map: this.aMap,
                zIndex: 150,
              });
              AMap.event.addListener(marker, 'click', (e) => {
                this.leakOilPointInfo = item
                let infoboxHTML = this.$refs.leakOilInfoBox
                this.oilLeakageBox.setContent(infoboxHTML)
                this.oilLeakageBox.open(this.aMap, marker.getPosition());
              });
              this.leakmarks.push(marker)
            })
          },
          showalarmMarks() {
            this.alarmData.forEach(item => {
              let icons = require(`@/assets/image/mapMark/alarmPoint.png`)
              let markIcon = new AMap.Icon({
                size: new AMap.Size(80, 35),
                image: icons,
                imageSize: new AMap.Size(80, 35),
              });
              let marker = new AMap.Marker({
                position: [item.lng, item.lat],
                icon: markIcon,
                map: this.aMap,
                zIndex: 150,
              });
              AMap.event.addListener(marker, 'click', (e) => {
                this.alarmPointInfo = item
                let infoboxHTML = this.$refs.alarmInfoBox
                this.alarmBox.setContent(infoboxHTML)
                this.alarmBox.open(this.aMap, marker.getPosition());
              });
              this.alarmMarks.push(marker)
            })
          },
          showTrackPoint(type) {
            if (this.replayline.length > 0) {
              switch (type) {
                case 'park':
                  this.parkVisible = !this.parkVisible
                  this.parkBox.close()
                  break;
                case 'alarm':
                  this.alarmVisible = !this.alarmVisible
                  this.alarmBox.close()
                  break;
                case 'fuel':
                  this.fuelVisible = !this.fuelVisible
                  this.addOilBox.close()
                  break;
                case 'leak':
                  this.leakVisible = !this.leakVisible
                  this.oilLeakageBox.close()
                  break;
              }
            }
          },
          playProcessChange() {
            if (!this.isOnSlider) return false
            if (!this.mapMarker) return false
            this.mapMarker.stopMove()
            this.navgMove = false
            let stopPoint = parseInt(this.playProcess / 100 * this.replayLineArr.length)
            this.movePoint(stopPoint)
            // this.aMap.setCenter(this.mapMarker.getPosition());
          },
          drawMapMarker(val, ol) {
            let { status, direct, lng, lat, speed } = this.replayLineArr[val]
            var currentPosition = this.mapMarker.getPosition();

            // 当前经纬度和之前的经纬度如果距离小于5米，则无法触发 moveend 事件
            // 采用跳点方案，跳点后手动触发play方法
            let LngLat = new AMap.LngLat(lng, lat)
            if (this.isOutOfBounds([lng, lat], this.mapBounds)) {
              this.aMap.setCenter(LngLat);
            }

            let imagePath = `${imageArr[status]}${this.getDirectInfo(90).image}`
            let icons = require(`@/assets/image/monitornew/${imagePath}`)

            this.mapMarker.setIcon(icons)

            if (this.shouldJump(currentPosition.lng, currentPosition.lat, lng, lat, this.playspeed)) {
              this.mapMarker.stopMove();
              this.mapMarker.setPosition(LngLat);
              requestAnimationFrame(() => {
                this.drawContinue();
              });
            } else {
              this.mapMarker.moveTo(LngLat, this.playspeed)
            }
          },
          getDirectInfo(direct) {
            var rtDirect = {};
            if (direct > 27 && direct <= 72) {
              rtDirect.image = "45.png";
              rtDirect.direction = "东北";
            } else if (direct > 72 && direct <= 117) {
              rtDirect.image = "90.png";
              rtDirect.direction = "东";
            } else if (direct > 117 && direct <= 162) {
              rtDirect.image = "135.png";
              rtDirect.direction = "东南";
            } else if (direct > 162 && direct <= 207) {
              rtDirect.image = "180.png";
              rtDirect.direction = "南";
            } else if (direct > 207 && direct <= 252) {
              rtDirect.image = "225.png";
              rtDirect.direction = "西南";
            } else if (direct > 252 && direct <= 297) {
              rtDirect.image = "270.png";
              rtDirect.direction = "西";
            } else if (direct > 297 && direct <= 342) {
              rtDirect.image = "315.png";
              rtDirect.direction = "西北";
            } else {
              rtDirect.image = "0.png";
              rtDirect.direction = "北";
            }
            return rtDirect;
          },
          getPlayStatus() {
            return require(`@/assets/image/markPoints/${this.navgMove?'zanting':'bofang'}.png`)
          }
        },
    }
</script>

<style lang="scss">
    .amap-copyright {
        display: none !important;
        visibility: hidden !important;
    }
    .amap-logo {
        display: none !important;
    }
    .tagStyle {
        font-weight: 700 !important;
    }
    .amap-maptype-list {
      display: none!important;
    }
    .amap-maptype-wrap {
      display: none!important;
    } 
    .trackPlayback {
      position: relative;
      height: 100vh;
      overflow: hidden;
      background-color: #F5F5F5;
      &-header {
        position: fixed;
        width: 100vw;
        height: 50px;
        padding: 12.5px 15px;
        box-sizing: border-box;
        text-align: center;
        background-image: linear-gradient(109deg, #EBF3F9 41%, #F3F7FB 99%);
        top: 0;
        z-index: 2;
        .goBack {
            position: absolute;
            top: 15px;
            left: 15px;
            width: 12px;
            height: 21.5px;
            background: url('~@/assets/image/fanhui.png') no-repeat;
            background-size: 100% 100%;
        }
        .plateNumber {
            height: 26.5px;
            line-height: 26.5px;
            display: inline-block;
            font-family: PingFangSC;
            font-weight: 700;
            font-size: 19px;
            color: #000000;
            vertical-align: middle;
        }
      }
      .mapType {
        position: fixed;
        width: 90px;
        height: 28px;
        top: 64px;
        right: 15px;
        z-index: 2;
        border-radius: 4px;
        overflow: hidden;
        &>div {
          display: inline-block;
          font-size: 13px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          background-color: #fff;
          width: 50%;
          &.active {
            background-color: #00B3A0;
            color: #fff;
          }
        }
      }
      .keyPoints {
        position: fixed;
        width: 40px;
        height: 183px;
        top: 112px;
        right: 15px;
        z-index: 2;
        &>div {
          width: 40px;
          height: 40px;
          // box-shadow: 0 1px 2px 0 #CCCED1;
          border-radius: 6px;
          margin-bottom: 7.5px;
          &>img {
            width: 100%;
            height: 100%;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      &-map {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
      }
      .realtimeData {
        position: absolute;
        bottom: 67px;
        width: 100vw;
        height: 179px;
        background: #FFFFFF;
        border-radius: 21px 21px 0 0;
        box-sizing: border-box;
        padding: 15px 17px 0 17px;
        z-index: 2;
        .carDes {
          height: 42px;
          margin-bottom: 13.5px;
          .carImg {
            display: inline-block;
            height: 25px;
            vertical-align: middle;
            margin: 8.5 0 0 4px;
            &>img {
              height: 100%;
            }
          }
          .platenumber_alarm {
            width: 200px;
            display: inline-block;
            vertical-align: middle;
            margin-left: 15px;
            .platenumber {
              height: 24px;
              line-height: 24px;
              font-family: PingFangSC;
              font-weight: 700;
              font-size: 17px;
              color: #2C2E34;
            }
            .alarm {
              height: 18.5px;
              line-height: 18.5px;
              font-family: PingFangSC-Regular;
              font-size: 13px;
              color: #484A50;
            }
          }
          .closeIcon {
            width: 26px;
            height: 26px;
            line-height: 26px;
            font-size: 30px;
            opacity: .6;
            text-align: center;
            border-radius: 50%;
            display: inline-block;
            color: #969798;
            background-color: #F2F3F4;
            float: right;
            margin-right: 3px;
          }
        }
        .realtime {
          height: 17px;
          margin-bottom: 15px;
          &>span {
            display: inline-block;
          }
          .circle {
            width: 7.5px;
            height: 7.5px;
            border-radius: 50%;
            background-color: #00B38A;
            margin: 0 10px 0 5px;
            vertical-align: middle;
          }
          .time {
            height: 17px;
            line-height: 17px;
            font-family: PingFangSC;
            font-weight: 700;
            font-size: 12px;
            color: #01A680;
            vertical-align: middle;
          }
        }
        .carCurrentMsg {
          height: 60px;
          background: #F3F8FB;
          border-radius: 8.5px;
          display: flex;
          justify-content: space-around;
          .item {
            flex: 1;
            text-align: center;
            .label {
              height: 18px;
              line-height: 18px;
              font-family: PingFangSC-Regular;
              font-size: 12.5px;
              color:#484A50;
              margin-top: 1px;
            }
            .value {
              height: 23.5px;
              line-height: 23.5px;
              font-family: DINAlternate;
              font-size: 20px;
              color: #414852;
              margin-top: 8.5px;
              .count {
                font-family: PingFangSC-Regular;
                font-size: 10px;
                color: #4A4E53;
              }
            }
          }
        }
      }
      .realtimeData-enter-active,
      .realtimeData-leave-active {
        transition: all .2s;
      }
      .realtimeData-enter,
      .realtimeData-leave-to {
        height: 0;
      }
      .tripMsg {
        position: absolute;
        width: 100vw;
        height: 194.5px;
        bottom: 67px;
        background: #FFFFFF;
        box-shadow: 0 1px 11px 0 #E4E9EE;
        border-radius: 17px 17px 0 0;
        z-index: 2;
        .carDes {
            height: 118.5px;
            box-sizing: border-box;
            padding-left: 14.5px;
            .tripDate {
                height: 46px;
                line-height: 46px;
                box-sizing: border-box;
                border-bottom: 1px solid rgba(203,208,214,.5);
                font-family: PingFangSC;
                font-weight: 700;
                font-size: 13.5px;
                color: #484A50;
                img {
                    width: 21px;
                    height: 21px;
                    vertical-align: middle;
                    margin-right: 10px;
                }
            }
            .tripAddress {
                margin-top: 12.5px;
                border-radius: 17px;
                .marks {
                    display: inline-block;
                    width: 7px;
                    height: 42px;
                    box-sizing: border-box;
                    padding: 6px 0;
                    margin: 0 8px 0 4.5px;
                    .circleGreen {
                        width: 7px;
                        height: 7px;
                        border-radius: 50%;
                        background: #00D6A5;
                    }
                    .circlePink {
                        width: 7px;
                        height: 7px;
                        border-radius: 50%;
                        background: #FF5961;
                    }
                    .line {
                        width: 2px;
                        height: 16.5px;
                        background: #E5E7EA;
                        margin-left: 2.5px;
                    }
                }
                .value {
                    display: inline-block;
                    font-family: PingFangSC;
                    font-weight: 700;
                    font-size: 13px;
                    color: #2C2E34;
                    p {
                        display: block;
                        height: 18.5px;
                        line-height: 18.5px;
                        width: 340px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
        .carMsg {
            height: 60px;
            background: #F3F8FB;
            border-radius: 8.5px;
            display: flex;
            box-sizing: border-box;
            margin: 0 17px;
            padding: 8.5px 0;
            &-item {
                flex: 1;
                text-align: center;
                .value {
                    font-family: DINAlternate;
                    font-size: 20px;
                    font-weight: 700;
                    color: #414852;
                    height: 23.5px;
                    line-height: 23.5px;
                    margin-bottom: 1px;
                    span {
                        font-family: PingFangSC-Regular;
                        font-size: 10px;
                        font-weight: normal;
                        color: #4A4E53;
                    }
                }
                .label {
                    font-family: PingFangSC-Regular;
                    font-size: 12.5px;
                    color: #484A50;
                    height: 18px;
                    line-height: 18px;
                }
            }
        }
      }
      .tripMsg-enter-active,
      .tripMsg-leave-active {
        transition: all .2s;
      }
      .tripMsg-enter,
      .tripMsg-leave-to {
        height: 0;
      }
      .realtimeDataMini {
        position: absolute;
        bottom: 138px;
        right: 0;
        width: 180px;
        height: 49px;
        line-height: 49px;
        background-image: linear-gradient(170deg, #EAFBF7 0%, #FFFFFF 49%);
        box-shadow: 0 0.5px 2.5px 1.5px #E0E3E8;
        border-radius: 50px 0 0 50px;
        box-sizing: border-box;
        padding-left: 15px;
        z-index: 3;
        img {
          display: inline-block;
          vertical-align: middle;
        }
        .line {
          display: inline-block;
          width: 0.5px;
          height: 21.5px;
          background-color: rgba(151,151,151,.3);
          margin: 0 5.5px 0 9px;
          vertical-align: middle;
        }
        .speed {
          display: inline-block;
          font-family: DINAlternate;
          font-weight: 700;
          font-size: 20px;
          color: #00B38A;
          vertical-align: middle;
          .count {
            font-family: PingFangSC-Regular;
            font-size: 10px;
            color: #4A4E53;
            font-weight: normal;
          }
        }
      }
      .trackPlayback-process {
        position: absolute;
        width: 100vw;
        height: 3px;
        bottom: 64px;
        z-index: 5;
        background-color:rgba(44, 172, 133, 0.5);
        .custom-button {
          width: 17px;
          height: 17px;
          box-sizing: border-box;
          border-radius: 50%;
          background: #FFFFFF;
          border: 2.5px solid #00B38A;
        }
      }
      .playKey {
        position: absolute;
        height: 64px;
        width: 100vw;
        bottom: 0;
        z-index: 3;
        text-align: center;
        background: #1E1F20;
        box-shadow: 0 -1px 0 0 #B5BBC3;
        // span {
        //   height: 100%;
        //   vertical-align: middle;
        //   display: inline-block
        // }
        &>div {
          width: 40px;
          height: 40px;
          margin: 12px auto;
          &>img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .transback-infobox,
      .transback-pointInfo {
        position: relative;
        width: 294px;
        box-sizing: border-box;
        background: #fff;
        padding: 10px;
        box-shadow: 0 2px 10px 0 #cdd2d1;
        .transback-item {
          font-size: 12px;
          color: #464c5b;
          margin-top: 6px;
          span {
            font-weight: bold;
            color: #000;
          }
        }
        .close-icon {
          position: absolute;
          right: 10px;
          top: 11px;
          color: #8d949f;
          font-size: 22px;
          cursor: pointer;
          z-index: 999;
        }
        &::after {
          border: solid transparent;
          content: " ";
          height: 0;
          bottom: -14px; //根据三角形的位置，可以随意更改。
          left: 50%;
          transform: translateX(-50%);
          position: absolute;
          width: 0;
          border-width: 15px 10px 0px 10px;
          border-top-color: #fff;
        }
      }
    }
</style>